import { defaultPm2PrintChunkClassName } from '@provider/print';
import { printAccordionComponent } from './printer.to-jsx.js';

const printAccordionComponentPaper = (node, context) => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: printAccordionComponent({
      ...node,
      options: {
        ...node.options,
        autoCollapse: false
      },
      children: node.children.map(child => ({
        ...child,
        options: {
          ...child.options,
          expandedInitially: true
        }
      }))
    }, context)
  }];
};
const accordionComponentPaperPrinters = {
  "accordion-component": printAccordionComponentPaper
};

export { accordionComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
